import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Divider} from 'views/components';
import {RefreshWidget} from 'views/module';

import JobName from './job_name/JobName';
import JobStatus from './job_status/JobStatus';

const JobTitle = (props) => {
  const {jobData, client, jobBackend, refresh, setRefresh} = props;

  return (
    <>
      <Stack
        direction='row'
        justifyContent={'space-between'}
        alignItems="center"
        sx={{
          p: 1,
          px: {md: 2, xs: 1},
        }}
      >
        <Box>
          <Stack
            direction='row'
            spacing={1}
          >
            <JobStatus
              jobData={jobData}
              jobBackend={jobBackend}
            />
            <JobName
              jobData={jobData}
              client={client}
              jobBackend={jobBackend}
            />
          </Stack>
        </Box>
        <Box sx={{minWidth: '37%'}}>
          <RefreshWidget numRefresh={refresh} setNumRefresh={setRefresh} justifyContent='end'/>
        </Box>
      </Stack>
      <Divider/>
    </>
  );
};
JobTitle.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
  jobBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(JobTitle);
